import { render } from "./Memory.vue?vue&type=template&id=2b7fc8f6&scoped=true"
import script from "./Memory.vue?vue&type=script&lang=js"
export * from "./Memory.vue?vue&type=script&lang=js"

import "./Memory.vue?vue&type=style&index=0&id=2b7fc8f6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7fc8f6"]])

export default __exports__